import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './selectable_record_table.scss';

const SelectableRecordTable = (props) => {
  const onCheckboxChangeHandler = isIndeterminate => isIndeterminate ? props.onResetSelection : props.onSelectAllToggle;

  const renderSelectAll = () => {
    const isIndeterminate = props.selectNoneVisible && !props.selectAllChecked;

    if (props.hasSelectAll) {
      return (
        <input
          aria-label="select all"
          checked={props.selectAllChecked}
          className="form-check-input"
          ref={input => input && (input.indeterminate = isIndeterminate)}
          type="checkbox"
          onChange={onCheckboxChangeHandler(isIndeterminate)}
        />
      );
    }
  };

  const tableClass = classNames(
    'table table-sticky table-hover',
    `table-sticky-col-${props.stickyColumns}`,
    {
      'table-sticky-last-col': props.stickyLastColumn,
    },
    props.className
  );

  return (
    <table className={tableClass} {...props.tableProps}>
      <thead
        className={classNames('', {
          'sticky-heading': props.stickyHeader,
        })}
      >
        <tr className={classNames({ 'd-none d-lg-table-row': props.responsive })}>
          {props.hasSelectColumn && (
            <th className="sticky-cell" key="select-all">{renderSelectAll()}</th>
          )}
          {props.columnHeaders}
        </tr>
        {props.headerRows}
      </thead>
      <tbody>{props.children}</tbody>
      {props.renderFooter ? props.renderFooter() : null}
    </table>
  );
};

SelectableRecordTable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  columnHeaders: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  hasSelectAll: PropTypes.bool,
  hasSelectColumn: PropTypes.bool,
  headerRows: PropTypes.node,
  renderFooter: PropTypes.func,
  responsive: PropTypes.bool,
  selectAllChecked: PropTypes.bool,
  selectNoneVisible: PropTypes.bool,
  stickyColumns: PropTypes.oneOf([0, 1, 2]),
  stickyHeader: PropTypes.bool,
  stickyLastColumn: PropTypes.bool,
  tableProps: PropTypes.object,
  onResetSelection: PropTypes.func,
  onSelectAllToggle: PropTypes.func,
};

SelectableRecordTable.defaultProps = {
  hasSelectAll: true,
  hasSelectColumn: true,
  responsive: true,
  selectAllChecked: false,
  selectNoneVisible: false,
  stickyColumns: 0,
  stickyHeader: false,
  stickyLastColumn: false,
};

export default SelectableRecordTable;
